module.exports = __webpack_public_path__ + "img/icon-arrow-down-light.1bfa83b1.svg";